// import PropTypes from 'prop-types';
import useGetStringAudio from 'utils/hooks/useGetStringAudio';

const withGetStringAudio = (WrappedComponent) => {
  const Wrapper = (props) => {
    //const getStringAudio = useGetStringAudio();
    const getStringAudio = useGetStringAudio(props.language || props.currentLang || props.locale);
    console.log('[withGetStringAudio] localeOverride:', props.language || props.currentLang || props.locale);

    return <WrappedComponent {...props} getStringAudio={getStringAudio} />;
  };
  return Wrapper;
};

export default withGetStringAudio;
